import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CartServiceProps } from '../types';
import { ServiceSummaryType } from '../../ServiceSummary/types';
import { CheckoutSteps } from '../../MobileStepbar/types';
import { CartContext } from '../Cart';
import ServiceSummaryCard from '../../ServiceSummary';
import { ServiceSummary } from '../../features/service-summary';
import { CdnIcon } from '@shared/ui';

const Seats: React.FC<CartServiceProps> = ({ travellers, activeStep, steps, onServiceDelete, renderService }) => {
	const cartContext = React.useContext(CartContext);

	const { t } = useTranslation('Cart');

	const seats = React.useMemo(() => {
		return travellers.filter(traveller => !!traveller.services.seats?.length);
	}, travellers);

	const group: ServiceSummaryType = {
		header: t('Seats'),
		icon: <CdnIcon icon={'Services/Seat Selection'} />,
		totalPrice: cartContext.totalPrices?.seats,
		disabled: activeStep < steps?.findIndex(step => step.type === CheckoutSteps.Seats)
	};

	if (!seats.length && !renderService) {
		return null;
	}

	return (
		<ServiceSummary serviceType="Seat" onDelete={onServiceDelete}>
			{content =>
				renderService?.(CheckoutSteps.Seats, group, content) ?? (
					<ServiceSummaryCard group={group}>{content}</ServiceSummaryCard>
				)
			}
		</ServiceSummary>
	);
};

export default Seats;
